<template>
  <div>
  <GmapMap
    :center="{lat: 44.801545, lng:20.458796}"
    :zoom="7"
    ref="map"
    :options="{ streetViewControl: true, clickableIcons: false }"
    :style="style"
  >
    <template v-for="(vehicle) in vehicles">
      <gmap-custom-marker
        v-show="vehicle.shouldDisplayOnMap()"
        :key="vehicle.id"
        :marker="{ lat: vehicle.latitude, lng: vehicle.longitude }"
      >
        <div v-if="getVehicleIcon(vehicle)" class="vehicleParent">
          <img class="imgA1" :height="getPixelCount(vehicle.pixelCount)" :width="getPixelCount(vehicle.pixelCount)" :src="getVehicleIcon(vehicle).url" @click="openVehicleInfoWindow(vehicle)" /><br>
          <img class="imgB1" v-if="vehicle.color == 1" :style="getStyle(vehicle)" :height="getPixelCount(vehicle.pixelCount, 10)" :width="getPixelCount(vehicle.pixelCount,10)"  src="/carret.png" alt="">
          <div v-if="vehicle.color != 1 && vehicle.isDataBuffering" class="google-loading-ring" :style="{ height: vehicle.pixelCount != null ? vehicle.pixelCount + 10 + 'px' : 60 + 'px', width: vehicle.pixelCount != null ? vehicle.pixelCount + 10 + 'px' : 60 + 'px'}"></div>
        </div>
      </gmap-custom-marker>
    </template>
    <template>
      <GmapInfoWindow v-if="selectedVehicle" :options="{ pixelOffset: { width:0, height: -30 }, zIndex: 100 }" :position="{ lat: selectedVehicle.latitude, lng: selectedVehicle.longitude}"  @closeclick="closeVehicleInfoWindow">
        <ImeiComponent :singleImei="selectedVehicle" style="width:420px; height:225px; overflow-x: hidden; overflow-y: hidden;"/>
      </GmapInfoWindow>
    </template>
    <template v-if="showTooltips" id="tooltip" width="100px">
      <GmapInfoWindow v-bind:key="vehicle.id" v-for="vehicle in vehicles" v-if="vehicle.shouldDisplayOnMap()" :options="{ pixelOffset: { width:0, height: -30 }, zIndex: 0, disableAutoPan:true }" :position="{ lat: vehicle.latitude, lng: vehicle.longitude} ">
          <span :style="[vehicleHasIOProperties(vehicle) ? {'background-color': getVehicleIoColor(vehicle)} : {} ]"> {{ showDriverNameOnLabels ? vehicle.driverName : vehicle.vehicleLabel}} </span>
      </GmapInfoWindow>
    </template>

      <!-- v-if="false" for a reason. If anytime client wanted to se vehicle movement trail, just remove v-if -->
    <template v-if="false" v-for="route in realTimeRoutes">
      <GmapPolyline
        v-if="needToDisplayRoute(route)"
        :key="route.id"
        :path="route.coordinatesGoogle"
        :options="{ strokeColor: route.color }"
      ></GmapPolyline>
    </template>

    <v-dialog width="360" v-model="showResultDialogLocal">
      <v-card>
        <v-card-text class="pt-6 pb-0">
          <v-simple-table dense height="auto">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left text-caption font-weight-bold">#</th>
                  <th class="text-left text-caption font-weight-bold">{{labels.headers.driver}}</th>
                  <th
                    class="text-left text-caption font-weight-bold"
                  >{{labels.headers.vehicleLabel}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selectedVehiclesToDisplay" :key="index">
                  <td class="text-caption font-weight-regular">{{index+1}}</td>
                  <td class="text-caption font-weight-regular">{{ item.driver }}</td>
                  <td class="text-caption font-weight-regular">{{ item.vehicleLabel }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end" no-gutters>
            <v-btn color="green darken-1" text @click="closeResultDialog">Zatvori</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </GmapMap>
  <v-dialog v-model="dialog.show" @keydown.esc="onCloseDialogHandler" max-width="380">
    <template v-if="dialog.show">
      <v-card flat tile>
        <BaseDialogTitle @close="onCloseDialogHandler">
          <template v-slot:title>Poi</template>
        </BaseDialogTitle>
        <v-card-text>
          <MapCrudComponent
            mapType="google"
            :mapData="mapCrudData"
            @closeMapCrudComponent="handleMapCrudComponentClose"
            :submited="dialog.submited"
            :closed="!dialog.show"
            @resetSubmit="dialog.submited=false"
          ></MapCrudComponent>
        </v-card-text>
        <v-card-actions>
          <SubmitGroup
            @close="onCloseDialogHandler"
            :closeOnSubmit="closeOnSubmit"
            @submit="onSubmitDialogHandler"
          />
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import translate from '@/utils/genTable/multilanguageHelper.js'
import BaseGoogleMapComponent from '../BaseGoogleMapComponent'
import EventBus from '../../../event-bus'
import store from '@/store/store'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import httpClient from '../../../api/httpClient'
import Vue from 'vue'

export default {
  name: 'GoogleRealTimeMapComponent',
  props: {
    height: Number | String
  },
  extends: BaseGoogleMapComponent,
  components: {
    ImeiComponent: () => import('../../map/imei/ImeiComponent'),
    'gmap-custom-marker': GmapCustomMarker
  },
  computed: {
    ...mapState('map', [
      'vehicles',
      'realTimeRoutes',
      'zoomMap',
      'zoomToVisible',
      'showDriverNameOnLabels',
      'showTooltips'
    ]),
    ...mapState('selectArea', [
      'polygon',
      'polylines',
      'selectedVehiclesToDisplay',
      'mapObject',
      'showResultDialog'
    ]),
    ...mapState('user', ['userDecoded']),
    google: gmapApi,
    style() {
      let style = 'width: 100%;'
      if (this.height == 'auto') {
        style += 'height: 94.4vh'
      } else {
        style += 'height:' + this.height + 'px;'
      }
      return style
    },
    showResultDialogLocal: {
      get() {
        return this.showResultDialog
      },
      set() {
        this.closeResultDialog()
      }
    }
  },
  data() {
    return {
      labels: {
        headers: {
          driver: translate('Driver Name', 'realtimeMap'),
          vehicleLabel: translate('Vehicle Label', 'realtimeMap')
        }
      },
      selectedVehicle: null
    }
  },
  async mounted() {
    EventBus.$on('SET_ZOOM_LEVEL', this.handleZoomLevel)
    EventBus.$on('VEHICLE_STREAM_PACKET_ARRIVED', this.handlePacketArrived)
    store.dispatch('selectArea/setMapObject', this.$refs.map)
 
    let tenant = await this.getTenantInfo()
    console.log(tenant)
    if (tenant.useTrafficLayer)
    {
      this.$refs.map.$mapPromise.then(map => {
          const trafficLayer = new google.maps.TrafficLayer()
          trafficLayer.setMap(map)
      })
    }
  },
  watch: {
    zoomMap: {
      handler() {
        var that = this
        that.$refs.map.$mapPromise.then(map => {
          let numberOfFocusedVehicles = []
          that.vehicles.forEach(vehicle => {
            if (vehicle.focused) {
              numberOfFocusedVehicles.push(vehicle)
            }
          })
          if (numberOfFocusedVehicles.length == 1) {
            var bounds = new that.google.maps.LatLngBounds()

            bounds.extend(
              new that.google.maps.LatLng(
                numberOfFocusedVehicles[0].latitude,
                numberOfFocusedVehicles[0].longitude
              )
            )
            map.fitBounds(bounds)
            map.setZoom(14)
          } else {
            this.setZoomLevelToFocusedVehicles()
          }
        })
      }
    },
    zoomToVisible: {
      handler() {
        this.handleZoomLevel()
      }
    }
  },
  methods: {
    getStyle(vehicle){
      return "top:-5px; transform: rotate(" + (vehicle.angle - 180) + "deg);"
    },
    getVehicleIcon(vehicle) {
      if (this.google) {
        var iconColor = 'greencar'

        if (vehicle.color == 1) {
          iconColor = 'greencar'
        } else if (vehicle.color == 2) {
          iconColor = 'bluecar'
        } else if (vehicle.color == 4) {
          iconColor = 'yellowcar'
        } else {
          iconColor = 'redcar'
        }

        if (vehicle.poi) {
          iconColor = iconColor + 'animated'
        }

        return {
          url: `${process.env.VUE_APP_S3_DOMAIN}/icons/${
            vehicle.icon
          }?i=${iconColor}`,
          scaledSize: { width: 30, height: 30, f: 'px', b: 'px' },
          labelOrigin: new this.google.maps.Point(11, 35)
        }
      }
    },
    getPixelCount(pixelCount, additional) {
      let pixels = 30
      if (pixelCount != null) {
        pixels = pixelCount
      }
      let imageSize = (pixels + (additional ? additional : 0)) + 'px'
      return imageSize 
    },
    handleZoomLevel() {
      if (this.google && this.$refs.map) {
        this.$refs.map.$mapPromise.then(map => {
          var bounds = new this.google.maps.LatLngBounds()
          this.vehicles.forEach(vehicle => {
            bounds.extend(
              new this.google.maps.LatLng(vehicle.latitude, vehicle.longitude)
            )
          })

          map.fitBounds(bounds)
        })
      }
    },
    closeResultDialog() {
      store.dispatch('selectArea/showResultDialog', false)
    },
    async openVehicleInfoWindow(index) {
      this.selectedVehicle = index

      let coordinates = [{
        latitude: this.selectedVehicle.latitude,
        longitude: this.selectedVehicle.longitude
      }];

      let coordinatesResponse = await httpClient.post('lookup/locations', coordinates);
      let currentLocation = coordinatesResponse.data[0];
      if(currentLocation) {
        Vue.set(this.selectedVehicle, 'currentLocation', currentLocation.address)
      }
    },
    closeVehicleInfoWindow() {
      this.selectedVehicle = null
    },
    setZoomLevelToFocusedVehicles(focusAll = true) {
      this.$refs.map.$mapPromise.then(map => {
        var bounds = new this.google.maps.LatLngBounds()
        let itemsToZoomIn = 0
        this.vehicles.forEach(vehicle => {
          if (vehicle.shouldDisplay() && vehicle.focused) {
            itemsToZoomIn++
            bounds.extend(
              new this.google.maps.LatLng(vehicle.latitude, vehicle.longitude)
            )
          }
        })
        if (itemsToZoomIn) {
          map.fitBounds(bounds)
        } else if (focusAll) {
          this.handleZoomLevel()
        }
      })
    },
    needToDisplayRoute(item) {
      let focusedVehicles = this.vehicles.filter(x => !x.focused)
      if (focusedVehicles.length == this.vehicles.length && item.visible) {
        return true
      }
      let vehicle = this.vehicles.filter(x => (x.imei || x.vehicleId) == item.id)[0]
      if (!vehicle) {
        return false
      }
      if (item.visible && vehicle.focused) {
        return true
      }
      return false
    },
    handlePacketArrived(vehicleData) {
      let that = this
      that.$refs.map.$mapPromise.then(map => {
        let numberOfFocusedVehicles = []
        that.vehicles.forEach(vehicle => {
          if (vehicle.focused) {
            numberOfFocusedVehicles.push(vehicle)
          }
        })
        if (numberOfFocusedVehicles.length == 1) {
          if ((numberOfFocusedVehicles[0].imei || numberOfFocusedVehicles[0].vehicleId) == (vehicleData.imei || vehicleData.vehicleId)) {
            let zoom = map.getZoom()

            var bounds = new that.google.maps.LatLngBounds()

            bounds.extend(
              new that.google.maps.LatLng(
                numberOfFocusedVehicles[0].latitude,
                numberOfFocusedVehicles[0].longitude
              )
            )
            map.fitBounds(bounds)
            map.setZoom(zoom)
          }
        } else {
          let toZoom = false
          for (let vehicle of numberOfFocusedVehicles) {
            if ((vehicle.imei || vehicle.vehicleId) == (vehicleData.imei || vehicleData.vehicleId)) {
              toZoom = true
              break
            }
          }

          if (toZoom) {
            that.setZoomLevelToFocusedVehicles(false)
          }
        }
      })
    },
    vehicleHasIOProperties(vehicle) {
      return vehicle.ioProperties.length
    },
    getVehicleIoColor(vehicle) {
      if(!vehicle.ioProperties.length) {
        return ''
      }
      return vehicle.ioProperties[0].ioColor ? vehicle.ioProperties[0].ioColor : vehicle.ioProperties[1] && vehicle.ioProperties[1].ioColor ? vehicle.ioProperties[1].ioColor : ''
    },
    async getTenantInfo(){
       let response = await httpClient.get(`/tenantSettings/${this.userDecoded.TenantId}`)
       return response.data
    }
  }
}
</script>

<style scoped>
#googleMap {
  width: 100%;
  height: 93.4vh;
}
.colorIOEvent {
  background-color: green;
  color: #fff;
}
</style>
